// System Features states

export default {
  systemMenu: {}
}
